import React from 'react';
import './Activity.css'

const Activity = (props) => {
    const {name, title, email, mobile, img,} = props.teacher;
    return (
        <div className='activity-class'>
            
            <img src={img} alt="" />
            <h2>{name}</h2>
            <h3>{title}</h3>
            <h3 style={{'color':'tomato'}}><u>E-mail:</u
            > {email}</h3>
            <h3>{mobile}</h3>
        </div>
    );
};

export default Activity;